// Added by Sejune Oh on 2019-02-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import logdown from 'logdown'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Logger Interface
export interface TLogger {
    devLog: (msg: string) => void
    errLog: (msg: string) => void
    infoLog: (msg: string) => void
    networkLog: (msg: string) => void
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Custom loggers
const devLogger = logdown('CoreLine:Dev >>\n', { prefixColor: '#1871b1' })
const errLogger = logdown('CoreLine:Err >>\n', { prefixColor: '#ff0000' })
const infoLogger = logdown('CoreLine:Info >>\n', { prefixColor: '#18b140' })
const networkLog = logdown('CoreLine:NETWORKD >>\n', { prefixColor: '#fb8e08' })
devLogger.state.isEnabled = true
errLogger.state.isEnabled = true
infoLogger.state.isEnabled = true
networkLog.state.isEnabled = true

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const Logger: TLogger = {
    devLog: (msg) => {
        devLogger.log(`${msg}\n`)
    },
    errLog: (msg) => {
        errLogger.log(`${msg}\n`)
    },
    infoLog: (msg) => {
        infoLogger.log(`${msg}\n`)
    },
    networkLog: (msg) => {
        networkLog.log(`${msg}\n`)
    },
}

export default Logger
